import jwtDecode, { type JwtPayload } from 'jwt-decode'
import { getWithExpiry } from '@util/LocalStorage'

const getSSN = (): number | null => {
    const token = getWithExpiry('token')
    const identity = jwtDecode<JwtPayload>(token) as any
    return identity?.ssn ?? null
}

const getFullName = (): string | null => {
    const token = getWithExpiry('token')
    if (!token) {
        return null
    }
    const identity = jwtDecode<JwtPayload>(token) as any
    return identity?.given_name || identity?.family_name
        ? `${identity?.given_name || ''} ${identity?.family_name || ''}`.trim()
        : null
}

const getEnevelopeCompletedBySelf = (state: any): boolean => {
    return !!state.recipients?.find((recipient: any) => recipient.ssnNumber === getSSN())?.completed
}

const formatDate = (date: string): string => {
    const dateObj = new Date(date || new Date());
    const formattedDate = new Intl.DateTimeFormat().format(dateObj);
    const formattedTime = new Intl.DateTimeFormat('default', {
        hour: '2-digit',
        minute: '2-digit'
    }).format(dateObj);
    
    return `${formattedDate}, ${formattedTime}`;
}

const checkSSnError = (ssn: string, signingMethod: string): boolean => {
    switch (signingMethod) {
        case 'bankid-no':
        case 'ee-id':
        case 'lt-id':
            return /^[0-9]{11}$/.test(ssn)
        case 'lv-id':
            // eslint-disable-next-line security/detect-unsafe-regex
            return /^(?=(?:\D*\d){11}\D*$)[0-9-]{12}$/.test(ssn)
    }
    return false
}

export { getSSN, getEnevelopeCompletedBySelf, formatDate, getFullName, checkSSnError }
